module.exports = __webpack_public_path__ + "img/CN-邀请2.f913c418.png";